import React from "react";
import { Check } from "lucide-react";
import { Reveal, SectionHeader } from "./Reveal";
import { WHY_CHOOSE_LIST } from "../data/content";

export default function About() {
  return (
    <section
      id="about"
      data-testid="about-section"
      className="relative py-24 md:py-32 overflow-hidden"
    >
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12 grid lg:grid-cols-2 gap-16 items-center">
        {/* Image side */}
        <Reveal className="relative order-2 lg:order-1">
          <div className="relative rounded-[2rem] overflow-hidden shadow-2xl shadow-jo-primary/10 border-4 border-white">
            <img
              src="https://images.pexels.com/photos/33175650/pexels-photo-33175650.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
              alt="Johar Softech team collaboration"
              className="w-full h-[520px] object-cover hover:scale-105 transition-transform duration-700"
            />
          </div>
          <div className="absolute -bottom-8 -right-4 sm:right-8 glass rounded-2xl px-7 py-6 text-center">
            <div className="text-5xl font-bold bg-gradient-to-br from-jo-primary to-jo-accent bg-clip-text text-transparent">
              8+
            </div>
            <div className="text-xs text-slate-500 font-semibold tracking-wide mt-1">
              YEARS OF TRUSTED
              <br />BUSINESS EXCELLENCE
            </div>
          </div>
        </Reveal>

        {/* Text side */}
        <div className="order-1 lg:order-2">
          <SectionHeader
            label="About Johar Softech"
            title="8 Years of Trusted Business Excellence"
            desc="Johar Softech is a trusted outsourcing and technology partner delivering innovative business solutions across multiple industries — spanning IT, BPO, Healthcare Process Management, Customer Support, Back Office Operations, Data Management and Business Consulting."
          />
          <Reveal delay={0.2}>
            <p className="mt-5 text-slate-600 font-light leading-relaxed">
              With a strong commitment to quality, innovation and customer satisfaction, we
              help organizations focus on their core business while we manage their
              operational excellence.
            </p>
          </Reveal>

          <div className="mt-9 grid sm:grid-cols-2 gap-x-6 gap-y-3.5">
            {WHY_CHOOSE_LIST.map((item, i) => (
              <Reveal key={item} delay={0.05 * i}>
                <div className="flex items-center gap-3">
                  <span className="h-6 w-6 rounded-full bg-jo-accent/15 flex items-center justify-center shrink-0">
                    <Check size={14} className="text-jo-accent" strokeWidth={3} />
                  </span>
                  <span className="text-sm font-medium text-slate-700">{item}</span>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
